<template>
  <div class="p20">
    <!-- 登录日志表格 -->
  </div>
</template>

<script>
export default {
  name: 'LoginLog',
  data() {
    return {
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    },
    fetchData() {
      // 这里添加数据获取逻辑
    }
  }
}
</script>

<style scoped>

</style>